export default __webpack_public_path__ + "static/media/chat_logo_diet.41f5a92f.svg";